import React, { useEffect, useMemo, useState } from "react";
import AppDropdown from "../../components/AppDropdown/AppDropdown";
import * as hrmsService from "../../services/hrmsService";

// The company directory (name + code only) is small and the same for everyone, so it is
// fetched once per page load and shared by every picker.
let directoryCache = null;
let directoryInflight = null;
const loadDirectory = () => {
  if (directoryCache) return Promise.resolve(directoryCache);
  if (!directoryInflight) {
    directoryInflight = hrmsService
      .getDirectory({ size: 200 })
      .then((res) => {
        directoryCache = res?.data?.rows || [];
        return directoryCache;
      })
      .catch(() => [])
      .finally(() => {
        directoryInflight = null;
      });
  }
  return directoryInflight;
};
export const resetDirectoryCache = () => {
  directoryCache = null;
  directoryInflight = null;
};

export function useDirectory() {
  const [rows, setRows] = useState(directoryCache || []);
  useEffect(() => {
    let alive = true;
    loadDirectory().then((r) => alive && setRows(r));
    return () => {
      alive = false;
    };
  }, []);
  return rows;
}

export const employeeLabel = (e) => `${e.full_name}${e.employee_code ? ` (${e.employee_code})` : ""}`;

// value: encrypted employee id (or "" / null). onChange(id | null).
// `exclude`: ids that must not be offered (for example the person themselves).
export default function EmployeeSelect({ value, onChange, placeholder = "Select employee", exclude = [], disabled, error }) {
  const rows = useDirectory();
  const options = useMemo(() => rows.filter((e) => !exclude.includes(e.employee_id)).map((e) => ({ label: employeeLabel(e), value: e.employee_id })), [rows, exclude]);
  return <AppDropdown value={value || null} options={options} onChange={(e) => onChange(e.value || null, (options.find((o) => o.value === e.value) || {}).label)} placeholder={placeholder} filter disabled={disabled} error={error} />;
}
